import { Injectable } from '@angular/core';
import { Location } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class DemoozNavigationService {

    loading: any;
    private history: string[] = [];
    
    constructor(        
        private router: Router, 
        private location: Location,
        private navController: NavController,
    ) {
        this.router.events.subscribe(async (event) => {           
            if (event instanceof NavigationEnd) {               
                let lastHistory = null;
                if (this.history.length > 0) {
                    lastHistory = this.history[this.history.length-1];
                }
                if(lastHistory != event.urlAfterRedirects){
                    this.history.push(event.urlAfterRedirects);
                }
            }
        });
    }

    back(route:string|null = null, params:any = null): void {     
        this.history.pop();
        if (this.history.length > 0) {
            this.location.back();
        } 
        else if(route){            
            this.navController.navigateRoot(route, {queryParams: params, replaceUrl: true});
        }
        else {
            this.navController.navigateRoot('/');
        }
    }
    
    canGoBack(): boolean{
        return (this.history.length > 0 && ["/", "/home"].indexOf(this.history[this.history.length-1]) === -1);
    }
}
